import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatFormField } from '@angular/material/form-field'
import { ElderLabelInputComponent, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AttachmentSpec, AttachmentSpecType } from '../attachment-spec'
import { AttachmentSpecTypeSelectDirective } from '../attachment-spec-type-select.directive'
import { AttachmentTypeSelectDirective } from '../attachment-type-select.directive'
import { MexusEntitySelectDirective } from '../mexus-entity-select.directive'

@Component({
  selector: 'app-attachment-spec-detail',
  templateUrl: './attachment-spec-detail.component.html',
  styleUrls: ['./attachment-spec-detail.component.scss'],
  imports: [
    MatFormField,
    ElderSelectComponent,
    AttachmentSpecTypeSelectDirective,
    FormsModule,
    AttachmentTypeSelectDirective,
    MexusEntitySelectDirective,
    ElderLabelInputComponent,
    ElderTranslatePipe,
  ],
})
export class AttachmentSpecDetailComponent {
  attachment = input.required<AttachmentSpec>()

  AttachmentSpecType = AttachmentSpecType
}
